export enum SideMenuType {
    LEGACY = 'LEGACY',
    ICON = 'ICON',
    DETAILED = 'DETAILED'
}
